module.exports = __webpack_public_path__ + "img/distance.03e24739.svg";